import Model from "../Model";
import tw from "tailwind-styled-components";
import { DeleteBtn, SideCancelBtn, SubmitBtn } from "../Styles/InputStyles";

const DeleteStaff = ({
    setIsDeleteStaff,
    selectedData,
    deleteStaffLoading,
    deleteStaffMutate,
    handleClose
}) => {
    const handleDeleteSubmit = () => {
        deleteStaffMutate({
            id: selectedData?.id,
        });
    };
    return (
        <Model
            width="w-full max-w-md"
            setOpenModel={setIsDeleteStaff}
            title="Confirm Deletion"
        >
            <WarningText>
                {/* Are you sure you want to delete this staff? */}
                Are you sure you want to delete the staff ‘{selectedData?.name}’?
            </WarningText>

            <div className="w-full flex justify-between space-x-6 my-4">
                <SideCancelBtn
                    type="button"
                    onClick={handleClose}
                >
                    Cancel
                </SideCancelBtn>
                <DeleteBtn
                    onClick={handleDeleteSubmit}
                    disabled={deleteStaffLoading}
                    className="border border-red-500 bg-white text-red-500 hover:bg-red-500 hover:text-white"
                >
                    {deleteStaffLoading ? "Deleting..." : "Delete"}
                </DeleteBtn>
            </div>
        </Model>
    );
};

const WarningText = tw.p`text-gray-500 text-base mb-4`;

export default DeleteStaff;